/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import PageToolbar from "../../components/PageToolbar";
import { Button, Card, Checkbox, Row, Col, Form, InputNumber, message } from "antd";
import GenericSelector from "../../components/GenericSelector";
import GenericSelectorSuppliers from "../../components/GenericSelectorSuppliers";
import TableIDs from "../../data/TableIDs";
import GenericSelectorItemTags from "../../components/GenericSelectorItemTags";
import GenericModal from "../../components/GenericModal";
import ResponsiveTable from "../../components/ResponsiveTable";
import { Job, OutputType, ProcessType, User } from "../../JmReact";


class OrderRecommendation extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            supplierId: null,
            storageId: null,
            marlog: null,
            itemTagList: "",
            isSuppDefault: "1",
            isCostValue: "1",

            modalCalcItems: false,
            modalCalcItemsSearch: "",

            modalFilter: false,
            modalFilterOnlyChecked: false,
            modalFilterStockByMinimum: false,
            modalFilterOnlyRecommendation: false,

            loading: false,
        };

        this.id = "ORDER_RECOMMENDATION";

        this.api = {
            get: "get_order_recommendation",
            get_numerator: "get_order_recommendation_doc_numerator"
        }

        this.selectors = [
            { id: TableIDs.genericSelectorStorages, api: "get_storage_list" },
            { id: "INTERNAL_SUPPLIER_LIST", api: "internal_supplier_list" },
        ]

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };

        this.selectors.forEach((x) => {
            if (props.data[x.id] === undefined) { props.data[x.id] = { ...props.data.genericSelector } }
        })


    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(21615);
    }

    apiCalcItems = () => {
        const { supplierId, storageId, marlog, itemTagList, isSuppDefault, isCostValue } = this.state
        if (!supplierId || !storageId || !marlog) {
            message.error(this.getText(21631));
            return;
        }
        this.setState({ modalCalcItems: true }, () => {
            const request = { supplierId, storageId, marlog, itemTagList, isSuppDefault, isCostValue }
            this.props.dataActions.genericDataSetFilter(this.id, this.props.user.companyCode, this.props.user.token, request, this.api.get)
        })
    }

    renderCalcItemCheckbox = (text, record) => {
        let data = [...this.props.data[this.id].data]
        let dataStateFilter = data ? data.filter(f => {
            let y = f.split("\f")
            if (this.state.modalCalcItemsSearch && f.indexOf(this.state.modalCalcItemsSearch) == -1) return false;
            else if (this.state.modalFilterOnlyChecked && y[7] != 1) return false;
            else if (this.state.modalFilterStockByMinimum && y[4] > y[5]) return false;
            else if (this.state.modalFilterOnlyRecommendation && y[12] <= 0) return false;
            else return true
        }) : []
        if (text == "All") {
            let filterChecked = dataStateFilter.filter(f => f?.split("\f")[7] == 1)
            return (<Checkbox
                checked={dataStateFilter.length && dataStateFilter.length == filterChecked.length}
                indeterminate={dataStateFilter.length && filterChecked.length && dataStateFilter.length != filterChecked.length}
                onChange={e => {
                    data = data.map(r => {
                        let y = r.split("\f")
                        if (this.state.modalCalcItemsSearch && r.indexOf(this.state.modalCalcItemsSearch) == -1) return r
                        else if (this.state.modalFilterOnlyChecked && y[7] != 1) return r;
                        else if (this.state.modalFilterStockByMinimum && y[4] > y[5]) return r;
                        else if (this.state.modalFilterOnlyRecommendation && y[12] <= 0) return r;
                        else return y.map((x, i) => i == 7 ? (e.target.checked ? "1" : "0") : x).join("\f")
                    })

                    this.props.dataActions.setJson(this.id, { data })
                }} />)
        } else {
            return (<Checkbox checked={text == '1'} onChange={e => {
                data[record.index] = data[record.index].split("\f").map((x, i) => i == 7 ? (e.target.checked ? "1" : "0") : x).join("\f")
                this.props.dataActions.setJson(this.id, { data })
            }} />)
        }
    }

    renderOrderInput = (text, record, colIndex) => {
        return (<InputNumber min={0} value={text} onChange={e => {
            let data = [...this.props.data[this.id].data]
            let iAllOrder = 0;
            data[record.index] = data[record.index].split("\f").map((x, i) => {
                if (i < 13) {
                    return x
                } else if (i == 15) {
                    return iAllOrder
                } else {
                    let res = i == colIndex ? e : x;
                    iAllOrder += parseFloat(res ? res : 0)
                    return res
                }
            }).join("\f")
            this.props.dataActions.setJson(this.id, { data })
        }} />)
    }

    sendAPI = (script, data, sCallback) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        if (typeof data === "string") job.setInput(data);
        else data.map((x) => { job.setSection(x.section, x.data) })
        job.send("/cgi-bin/CashOnTab", sCallback, e => { console.error(e) });
    }


    createSuppOrderDoc = (rowsData, supplierId, isMarlog, next) => {
        this.setState({ loading: true }, () => {

            this.sendAPI(this.api.get_numerator, '_supplierId\r' + supplierId, ob => {
                if (ob.data) {
                    const [number, pos, employee, sName, sPhone, sAddress] = ob.data.split("\f")

                    let totalWithTax = 0;
                    let totalNoTax = 0;
                    let vatData = []

                    let linesSection = "LineVATPercent\fLineVATType\fLineTotalValueWithTax\fLineTotalValueNoTax\fLineReducPercent\f"
                        + "LineUnitPriceWithTax\fLineUnitPriceNoTax\fLineQuantity\fLineDesc\fLineItemBarcode\fLineItemCode\fLineNumber\fLineRemarks\f"
                        + "LineDocPosID\fLineDocTypeID\fLineDocNum\fLineUnitID\fLineQuantityInUnit\fLineUnitQuantity\f"
                        + "LineCurrencyCost\fLineCurrencyCode\fLineCurrencyRate\fLineSN\fLineDscnt1\fLineDscnt2\fLineDscnt3"

                    rowsData.forEach((x, i) => {
                        const {
                            iCode, iBarcode, iName, iTaxType, iTaxPercentage, iCost, iCostWithTax,
                            iCurrencyCode, iCurrencyRate, iCurrencyCost, iSizeID, iSizeQty,
                            iMarlogOrder, iSupplierOrder
                        } = x

                        let qty = isMarlog ? iMarlogOrder : iSupplierOrder
                        let unitQty = parseInt(parseFloat(qty) / (parseFloat(iSizeQty) ?? 1))
                        let priceNoTax = (parseFloat(iCost) ?? 0)
                        let priceWithTax = (parseFloat(iCostWithTax) ?? 0)
                        let lineTotalNoTax = priceNoTax * qty
                        let lineTotalWithTax = priceWithTax * qty

                        linesSection += "\r" + iTaxPercentage + "\f" + iTaxType + "\f" + lineTotalWithTax.toFixed(2) + "\f" + lineTotalNoTax.toFixed(2) + "\f0.00\f"
                            + priceWithTax.toFixed(2) + "\f" + priceNoTax.toFixed(2) + "\f" + qty + "\f" + iName + "\f" + iBarcode + "\f" + iCode + "\f" + (i + 1) + "\f\f"
                            + pos + "\f15\f" + number + "\f" + iSizeID + "\f" + iSizeQty + "\f" + unitQty + "\f"
                            + iCurrencyCost + "\f" + iCurrencyCode + "\f" + iCurrencyRate + "\f\f0.00\f0.00\f0.00"

                        let findVat = vatData.findIndex(f => f.id == iTaxType && f.percent == iTaxPercentage)
                        if (findVat == -1) vatData.push({ id: iTaxType, percent: iTaxPercentage, noTax: lineTotalNoTax, tax: (lineTotalWithTax - lineTotalNoTax) })
                        else vatData[findVat] = { ...vatData[findVat], noTax: vatData[findVat].noTax + lineTotalNoTax, tax: vatData[findVat].tax + (lineTotalWithTax - lineTotalNoTax) }

                        totalNoTax += lineTotalNoTax
                        totalWithTax += lineTotalWithTax

                    })

                    let vatSection = 'DocsPartVAT\fDocsPartNoVAT\fDocsVATPercent\fDocsVATTypeID\fDocsVATPosID\fDocsVATDocTypeID\fDocsVATDocNum'

                    vatData.forEach(x => {
                        vatSection += '\r' + x.tax + '\f' + x.noTax + '\f' + x.percent + '\f' + x.id + '\f' + pos + '\f15\f' + number
                    })

                    let docsSection = 'DocCustTel\fDocCustZip\fDocCustAddr\fDocCustName\fDocCustID\fDocWorker\f'
                        + 'DocTotal\fDocTotalVAT\fDocTotalNoVAT\fDocRoundSum\fDocReservedNum\fDocZnum\fDocRemarks\f'
                        + 'DocDateTime\fDocPosID\fDocTypeID\fDocNum\fDocStorageId\fDocRef2\r'
                        + sPhone + '\f\f' + sAddress + '\f' + sName + '\f' + supplierId + '\f' + employee + '\f'
                        + totalWithTax.toFixed(2) + '\f' + (totalWithTax - totalNoTax).toFixed(4) + '\f' + totalNoTax.toFixed(4) + '\f0.0000\f0\f0\f\f'
                        + Math.floor(Date.now() / 1000) + '\f' + pos + '\f15\f' + number + '\f' + this.state.storageId + '\f';


                    this.sendAPI("create_new_document", [
                        { section: "Docs", data: docsSection },
                        { section: "Lines", data: linesSection },
                        { section: "DocsVat", data: vatSection },
                        { section: "DateVal", data: "" },
                        { section: "PayDate", data: "" },
                        { section: "Transactio", data: "" },
                        { section: "Signatures", data: "" },
                    ], () => {
                        let params = {
                            DocumentNumber: number,
                            DocumentTypeID: 15,
                            DocumentPOSID: pos,
                            userID: this.props.user.userId,
                            userName: encodeURIComponent(this.props.user.displayName),
                            CompanyCode: this.props.user.companyCode,
                            isOriginal: false,
                            CentralFatherItem: 0,
                            PrintFormat: null,
                            docIsWithSigns: 0,
                            reportName: "reports/DocumentCopy.pdf",
                            REPORT_LOCALE: this.getText(101)
                        }
                        this.props.ActionQueue.addToQueue({
                            action: this.props.dataActions.generateReport,
                            args: [this.props.user.companyCode, this.props.user.token, params]
                        });

                        next()

                    })

                } else {
                    this.setState({ loading: false })
                    message.error(this.getText(21703))
                }
            })

        })
    }

    createDocs = () => {

        const { supplierId, marlog } = this.state

        const { data, headers } = this.props.data[this.id]

        let marlogData = []
        let supplierData = []
        data.forEach(x => {
            let y = x.split("\f")
            let res = {}
            headers.forEach((z, i) => { res = { ...res, [z]: y[i] } })
            if (res.iIsChecked == 1) {
                if (res.iMarlogOrder > 0) marlogData.push(res)
                if (res.iSupplierOrder > 0) supplierData.push(res)
            }
        })

        let endCreateDoc = () => { this.setState({ loading: false, modalCalcItems: false }) }

        if (marlogData.length && supplierData.length) {
            this.createSuppOrderDoc(marlogData, marlog, true, () => {
                this.createSuppOrderDoc(supplierData, supplierId, false, endCreateDoc)
            })
        } else if (marlogData.length) {
            this.createSuppOrderDoc(marlogData, marlog, true, endCreateDoc)
        } else if (supplierData.length) {
            this.createSuppOrderDoc(supplierData, supplierId, false, endCreateDoc)
        } else {
            endCreateDoc()
        }

    }

    filterField = (label, field) => {
        return (<Form.Item>
            <Checkbox
                checked={this.state[field]}
                onChange={e => { this.setState({ [field]: e.target.checked }) }}
            >{this.getText(label)}</Checkbox>
        </Form.Item>)
    }

    render() {
        const gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            flexDirection: 'column',
        };

        const { data, headers } = this.props.data[this.id]
        let marlogSum = 0;
        let supplierSum = 0;
        const dataSource = data.map((x, index) => {
            let y = x.split("\f")
            let res = { key: y[0], index, x }
            headers.forEach((z, i) => { res = { ...res, [z]: y[i] } })
            if (res.iIsChecked == 1 && res.iMarlogOrder > 0) marlogSum += parseFloat(res.iMarlogOrder)
            if (res.iIsChecked == 1 && res.iSupplierOrder > 0) supplierSum += parseFloat(res.iSupplierOrder)
            return res
        }).filter(f => {
            if (this.state.modalCalcItemsSearch && f.x.indexOf(this.state.modalCalcItemsSearch) == -1) return false;
            else if (this.state.modalFilterOnlyChecked && f.iIsChecked != 1) return false;
            else if (this.state.modalFilterStockByMinimum && f.iStock > f.iMinStock) return false;
            else if (this.state.modalFilterOnlyRecommendation && f.iRecommendation <= 0) return false;
            else return true
        })

        let allSum = (marlogSum + supplierSum).toFixed(2)
        marlogSum = marlogSum.toFixed(2)
        supplierSum = supplierSum.toFixed(2)

        console.log("data[record.index]", dataSource)


        return (<div style={divStyle}>
            <Card title={<PageToolbar title={gt(21616)} actionButtons={[]} />}
                bordered={true} style={{ width: window.innerWidth > 700 ? 700 : "95%" }}
                headStyle={{ paddingLeft: 8, paddingRight: 8, marginTop: 4, height: 56 }}
                actions={[<Button type="primary" onClick={this.apiCalcItems}>{gt(21623)}</Button>]}>

                <Form.Item label={gt(21617)} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} required validateStatus={this.state.supplierId ? "success" : "error"}>
                    <GenericSelectorSuppliers
                        {...this.props}
                        value={this.state.supplierId}
                        onChange={e => { this.setState({ supplierId: e }) }}
                    />
                </Form.Item>
                <Row style={{ minHeight: 50 }}>
                    <Col span={6}></Col>
                    <Col span={18}>
                        <Checkbox
                            checked={this.state.isSuppDefault == 1}
                            onChange={e => { this.setState({ isSuppDefault: e.target.checked ? "1" : "0" }) }}
                        >{gt(21621)}</Checkbox>
                    </Col>
                </Row>
                <Row style={{ minHeight: 50 }}>
                    <Col span={6}></Col>
                    <Col span={18}>
                        <Checkbox
                            checked={this.state.isCostValue == 1}
                            onChange={e => { this.setState({ isCostValue: e.target.checked ? "1" : "0" }) }}
                        >{gt(21622)}</Checkbox>
                    </Col>
                </Row>

                <Form.Item label={gt(21618)} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} required validateStatus={this.state.storageId ? "success" : "error"}>
                    <GenericSelector
                        {...this.props}
                        {...this.selectors[0]}
                        value={this.state.storageId}
                        onChange={e => { this.setState({ storageId: e }) }}
                    />
                </Form.Item>
                <Form.Item label={gt(21619)} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} required validateStatus={this.state.marlog ? "success" : "error"}>
                    <GenericSelector
                        {...this.props}
                        {...this.selectors[1]}
                        value={this.state.marlog}
                        onChange={e => { this.setState({ marlog: e }) }}
                    />
                </Form.Item>
                <Form.Item label={gt(21620)} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} >
                    <GenericSelectorItemTags
                        {...this.props}
                        multi
                        value={this.state.itemTagList ? this.state.itemTagList.split(",") : []}
                        onChange={e => { this.setState({ itemTagList: e ? e.join(",") : "" }) }}
                    />
                </Form.Item>

            </Card>

            <GenericModal
                visible={this.state.modalCalcItems}
                onCancel={() => { this.setState({ modalCalcItems: false }) }}
                title={`${gt(21624)} ${this.state.storageId} - ${this.props.data[TableIDs.genericSelectorStorages].dataset.find(f => f.code == this.state.storageId)?.name}`}
                footer={[
                    <Button
                        type="primary"
                        style={{ marginLeft: 15 }}
                        disabled={!parseFloat(allSum)}
                        loading={this.state.loading}
                        onClick={this.createDocs}
                    >{gt(21634)}</Button>,
                    <Button
                        onClick={() => { this.setState({ modalCalcItems: false }) }}
                    >{gt(21635)}</Button>,
                ]}
                showsearch={() => { }}
                onChangeSearch={v => { this.setState({ modalCalcItemsSearch: v.target.value }) }}
                valueSearch={this.state.modalCalcItemsSearch}
                actionButtons={[{
                    buttonType: 'filter',
                    buttonFunction: () => { this.setState({ modalFilter: true }) }
                }]}
            >
                <ResponsiveTable
                    tableOnly
                    dataSource={dataSource}
                    columns={[
                        { title: gt(21625), key: "iCode", dataIndex: "iCode", width: "9%", render: t => t },
                        { title: gt(21626), key: "iBarcode", dataIndex: "iBarcode", width: "9%", render: t => t },
                        { title: gt(21627), key: "iName", dataIndex: "iName", width: "17%", render: t => t },

                        { title: gt(21628), key: "iStock", dataIndex: "iStock", width: "6%", render: t => parseFloat(t) < 0 ? `0 (${t})` : t },
                        { title: gt(21629), key: "iMinStock", dataIndex: "iMinStock", width: "6%", render: t => t },
                        { title: gt(21630), key: "iMarlogStock", dataIndex: "iMarlogStock", width: "6%", render: t => parseFloat(t) < 0 ? `0 (${t})` : t },
                        { title: gt(21670), key: "iAverageDemand", dataIndex: "iAverageDemand", width: "6%", render: t => t },
                        { title: gt(21663), key: "iRequiredStock", dataIndex: "iRequiredStock", width: "6%", render: (t, r) => `${t} (${r.iLimitDays} ${gt(21669)})` },
                        { title: gt(21664), key: "iSizeQty", dataIndex: "iSizeQty", width: "6%", render: t => t },
                        { title: gt(21665), key: "iRecommendation", dataIndex: "iRecommendation", width: "6%", render: t => t },
                        { title: gt(21666), key: "iMarlogOrder", dataIndex: "iMarlogOrder", width: "6%", render: (t, r) => this.renderOrderInput(t, r, 13) },
                        { title: gt(21667), key: "iSupplierOrder", dataIndex: "iSupplierOrder", width: "6%", render: (t, r) => this.renderOrderInput(t, r, 14) },
                        { title: gt(21668), key: "iAllOrder", dataIndex: "iAllOrder", width: "6%", render: t => t },

                        { title: this.renderCalcItemCheckbox("All"), key: "iIsChecked", dataIndex: "iIsChecked", width: "5%", render: this.renderCalcItemCheckbox },
                    ]}
                    pagination={{ pageSize: parseInt((window.innerHeight - 350) / 40) }}
                />

                <ResponsiveTable
                    tableOnly
                    dataSource={[{ key: "sumData", index: 0, marlogSum, supplierSum, allSum }]}
                    columns={[
                        { key: "col1", width: "77%", render: () => "" },
                        { title: gt(21698), key: "marlogSum", dataIndex: "marlogSum", width: "6%", render: t => t },
                        { title: gt(21699), key: "supplierSum", dataIndex: "supplierSum", width: "6%", render: t => t },
                        { title: gt(21700), key: "allSum", dataIndex: "allSum", width: "6%", render: t => t },
                        { key: "col5", width: "5%", render: () => "" },
                    ]}
                    pagination={false}
                />
            </GenericModal>
            <GenericModal
                visible={this.state.modalFilter}
                onCancel={() => { this.setState({ modalFilter: false }) }}
                title={gt(21693)}
                width={500}
                footer={[<Button onClick={() => { this.setState({ modalFilter: false }) }} >{gt(21692)}</Button>]}
            >
                {this.filterField(21694, "modalFilterOnlyChecked")}
                {this.filterField(21695, "modalFilterStockByMinimum")}
                {this.filterField(21696, "modalFilterOnlyRecommendation")}
            </GenericModal>
        </div>)
    }

}

export default OrderRecommendation;